export const classInfoDemoData: any = {
    class_name: '',
    school_name: ''
};
